import React, { PureComponent } from 'react'
import { withTranslation } from 'react-i18next'
import './styles.scss'
import PropTypes from 'prop-types'
import { getOptions } from '../../../../http/driveApiGateway/client'
import SingleGraphTable from './Widget/GraphTable/Single'
import DoubleGraphTable from './Widget/GraphTable/Double'

class Dashboard extends PureComponent {
  state = {
    widgets: [],
    layout: {
      dashboardStyle: 'dark'
    }
  }

  componentDidMount () {
    this.updateAllowedWidgets()
  }

  updateAllowedWidgets () {
    getOptions(this.props.giataId).fetchPromise
      .then((data) => {
        const widgets = []
        if (data.options.images) {
          widgets.push({
            component: SingleGraphTable,
            title: 'WIDGET_TITLE_IMAGE_SCORE',
            mainValueLabel: 'LABEL_IMAGES',
            overrideImageCount: this.props.confirmedImagesCount,
            scoreId: 4,
          })
        }
        if (data.options.distribution) {
          widgets.push({
            component: DoubleGraphTable,
            title: 'WIDGET_TITLE_DISTRIBUTION',
            mainValueLabel: 'LABEL_SUPPLIERS',
            scoreId: 1
          })
        }
        if (data.options.facts) {
          widgets.push({
            component: SingleGraphTable,
            title: 'WIDGET_TITLE_FACTS',
            mainValueLabel: 'LABEL_FACTS',
            scoreId: 3
          })
        }
        if (data.options.tourOperators) {
          widgets.push({
            component: DoubleGraphTable,
            title: 'WIDGET_TITLE_TOUR_OPERATORS',
            mainValueLabel: 'LABEL_TOUR_OPERATORS',
            scoreId: 2
          })
        }
        this.setState({
          widgets: widgets
        })
      })
  }

  onThemeSwitch = () => {
    if (this.state.layout.dashboardStyle === 'dark') {
      this.setState({ layout: { dashboardStyle: 'light' } })
    } else {
      this.setState({ layout: { dashboardStyle: 'dark' } })
    }
  }

  render () {
    return (
      <div
        className={'Dashboard ' +
          (this.state.layout.dashboardStyle === 'dark' ? 'Dashboard-dark Gradient' : 'Dashboard-light')}
        id="Dashboard">
        <div className="container clearfix">
          <span className="DashboardThemeSwitch" onClick={this.onThemeSwitch}><i
            className="im im-sun"></i><span><span></span></span></span>
        </div>
        <div className="container clearfix">
          <div className="Dashboard-Widgets">
            {this.state.widgets.map((widget, index) => {
              const CustomComponent = widget.component
              return <CustomComponent
                key={index} widget={widget}
                activeHotel={this.props.item}/>
            })}
          </div>
        </div>
      </div>
    )
  }
}

Dashboard.defaultProps = {}
Dashboard.propTypes = {
  permissions: PropTypes.object.isRequired,
  giataId: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  confirmedImagesCount: PropTypes.number.isRequired
}
export default withTranslation()(Dashboard)
